import React from "react";

const Text: React.FC<{ class?: string }> = props => {
  return <span className={` ${props?.class}`}>{props.children}</span>;
};

export default Text;
